import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const SuperAdminRoute = ({ children }) => {
    const { user, loading } = useContext(AuthContext);

    if (loading) return <div>Loading...</div>;

    // Strict check: ONLY 'superadmin' allowed
    if (user && user.role === 'superadmin') {
        return children;
    }

    // If they are a normal admin trying to be sneaky, send them back to Admin Dashboard
    if (user && user.role === 'admin') {
        return <Navigate to="/admin" />;
    }

    return <Navigate to="/dashboard" />;
};

export default SuperAdminRoute;